import { CompanyInfo } from "src/pages/OfferPage/QuoteHeader/CompanyInfo/CompanyInfo";
import 'src/styles/quote.css'
import { QuoteData } from "src/model/api/quote-data.model";
import { Box, Stack } from '@mui/material';

export const QuoteHeader = (props: { quoteData: QuoteData; }) => {
  const { quoteData } = props;

  return quoteData === null ? (
      <>
        <Stack direction="row" gap="10px" sx={{marginTop: '15px', padding: '5px'}}>
          <Box>
          <div
              style={{ width: "250px", marginBottom: "5px" }}
              className="placeholder-box quote-companyinfo-row"
          ></div>
          <div
              style={{ width: "250px", marginBottom: "5px" }}
              className="placeholder-box quote-companyinfo-row"
          ></div>
          <div
              style={{ width: "250px"}}
              className="placeholder-box quote-companyinfo-row"
          ></div>
          </Box>
          <Box flexGrow="1">
            <div
                style={{ width: "250px", marginBottom: "5px" }}
                className="placeholder-box quote-companyinfo-row"
            ></div>
            <div
                style={{ width: "250px", marginBottom: "5px" }}
                className="placeholder-box quote-companyinfo-row"
            ></div>
            <div
                style={{ width: "250px"}}
                className="placeholder-box quote-companyinfo-row"
            ></div>
          </Box>
          <Box style={{ width: "170px", height: "170px" }}
                className="placeholder-box">
          </Box>
        </Stack>
        <div className="quote-head-container quote-coverpage-elem">
          <div style={{ width: "100%" }} className="placeholder-box"></div>
        </div>
      </>
  ) : quoteData ? (
      <CompanyInfo quoteData={quoteData} />
  ) : null;
};
